export default function Go_Arithmetic() {
  return (
    <div>
      <h1>Go_Arithmetic </h1>
      <p>Arithmetic</p>
    </div>
  );
}
